import service from '@/store/services/settings/signatures-service';

const state = {
    me: null,
};

const mutations = {
    SET_RESOURCE: (state, me) => {
        state.me = me;
    }
};

const actions = {
    me ({ commit, dispatch }, params) {
        return service.get(params)
            .then((signature) => {
                commit('SET_RESOURCE', signature.list);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((signature) => {
                commit('SET_RESOURCE', signature);
            });
    },
};

const getters = {
    me: state => state.me
};

const signature = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default signature;
